// Vite glob requires a literal relative path (aliases are not supported).
const GRID_IMAGE_MODULES = import.meta.glob('../assets/auth/grid/*.{webp,png}', {
  eager: true,
  import: 'default',
});

export const AUTH_GRID_IMAGES = Object.entries(GRID_IMAGE_MODULES)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([, src]) => src);

const COLUMN_DURATIONS_SECONDS = [50, 60, 70, 45, 55, 65, 40];
const COLUMN_OFFSETS_PX = [0, 64, 24, 88, 16, 80, 40];

export function buildMarqueeColumns(images, { columnCount = 4 } = {}) {
  if (images.length === 0 || columnCount <= 0) {
    return [];
  }

  const buckets = Array.from({ length: columnCount }, () => []);
  images.forEach((src, imageIndex) => {
    buckets[imageIndex % columnCount].push(src);
  });

  return buckets.map((uniqueTiles, columnIndex) => {
    const id = `col-${columnIndex}`;
    const loopTiles = (half) => uniqueTiles.map((src) => ({
      key: `${id}-${half}-${src}`,
      src,
    }));

    return {
      id,
      direction: columnIndex % 2 === 0 ? 'up' : 'down',
      durationSeconds: COLUMN_DURATIONS_SECONDS[columnIndex % COLUMN_DURATIONS_SECONDS.length],
      offsetPx: COLUMN_OFFSETS_PX[columnIndex % COLUMN_OFFSETS_PX.length],
      // Identical second half is only for the translateY(-50%) loop.
      tiles: uniqueTiles.length > 0 ? [...loopTiles('a'), ...loopTiles('b')] : [],
    };
  });
}
